import React from 'react';
import PropTypes from 'prop-types';
import { CharacterLimitedTextArea } from '../../Features/common/CharacterLimitedTextArea';

export const DETAILS_LABEL_TEXT = 'Program Description';
export const DETAILS_PLACEHOLDER = 'Provide an overview of the program...';
export const DETAILS_TEXT_LIMIT = 1000;

const AffordableDetails = ({
  details,
  errorMessage,
  setDetails,
  setDetailsValidationErrorMessage,
}) => {
  const handleOnChange = (e) => {
    setDetails(e.target.value);
  };

  const handleOnBlur = (e) => {
    const { value } = e.target;
    setDetails(value.trim());
  };

  const handleOnFocus = () => {
    if (errorMessage) {
      setDetailsValidationErrorMessage('');
    }
  };

  return (
    <CharacterLimitedTextArea
      characterLimit={DETAILS_TEXT_LIMIT}
      error={Boolean(errorMessage)}
      helperText={errorMessage}
      label={DETAILS_LABEL_TEXT}
      onBlur={handleOnBlur}
      onChange={handleOnChange}
      onFocus={handleOnFocus}
      placeholder={DETAILS_PLACEHOLDER}
      value={details || ''}
    />
  );
};

AffordableDetails.propTypes = {
  details: PropTypes.string,
  errorMessage: PropTypes.string,
  setDetails: PropTypes.func,
  setDetailsValidationErrorMessage: PropTypes.func,
};

export default AffordableDetails;
